export class DepartmentWorkflow {
  workflowId: string;
  workflowName: string;

  constructor(options?: Partial<DepartmentWorkflow>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}
